export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/auth/login-ico-sns-line-0e091239442121e27f11b2d164eeef8a.svg";